export const testimonials = [
  {
    name: "Jennifer Brady",
    role: "Mom Extraordinaire",
    text: "With two kiddos at home, RUGGED RED is my lifesaver! It makes sticky spills vanish in seconds. I won't use anything else!",
    photo: "https://i.insider.com/6631073210dfcda40964d50f?width=700",
  },
  {
    name: "Alicia Rivera",
    role: "Auto Mechanic",
    text: "Oil stains, grease, you name it. RUGGED RED wipes it all away, saving me so much time in the shop. It's my go-to every day!",
    photo: "https://www.sheboygan.k12.wi.us/perch/resources/abigail-tagel-red-raider-manufacturing-1-600x400.jpg",
  },
  {
    name: "Marcus Klein",
    role: "CNC Factory Operator",
    text: "We rely on RUGGED RED to keep our machines and metal parts clean. It's the best industrial cleaner I've come across—hands down!",
    photo: "https://i.redd.it/72udgqzbsljb1.jpg",
  }
];